export const MIN_5 = 1000 * 5 * 60

export function refetchOnWindowFocus(query) {
  const last = query.state?.dataUpdatedAt ?? 0
  return Date.now() - last > MIN_5
}